import React from "react";

export const MenuContext = React.createContext();
export const MenuProvider = MenuContext.Provider;
export const MenuConsumer = MenuContext.Consumer;